import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AngularFireFunctions } from '@angular/fire/functions';
import { CommonService } from 'src/app/_services';

@Component({
  selector: 'app-legacy-redirect',
  templateUrl: './legacy-redirect.component.html',
  styleUrls: ['./legacy-redirect.component.scss'],
  providers : [AngularFireFunctions],
})
export class LegacyRedirectComponent implements OnInit {

  wid:string;
  alid:string;
  errMsg:string;
  constructor(
    private route: ActivatedRoute,
    private fns : AngularFireFunctions,
    private _common: CommonService
  ) { }


  ngOnInit(): void {
    this.route.queryParamMap.subscribe(queryParams => {
      this.wid = queryParams.get("wid");
      this.alid = queryParams.get("alid"); 
      this.getFormBaseUrl()
   })

  }
  getFormBaseUrl(){
    if(window.location.host.includes('localhost')){
      this.fns.functions.useFunctionsEmulator('http://localhost:5000');
    }
    this._common.showLoader(true);
    const baseUrl = this.fns.httpsCallable('get_system_form_base_url');
    baseUrl({}).subscribe((result) => {
      this._common.showLoader(false);
      if(result.outcome==="success"){
        const redirectUrl = result.data;
        window.location.href = `${result.data}/new/${this.wid}/${this.alid}`; 
      }
      else {
        this.errMsg = result.message;
      }
    },err=>{
      this._common.showLoader(false);
      this.errMsg = 'Something went wrong while fetching form base url';
    });
  }

}